import api from '@/lib/axios';

export interface Gasto {
  id: string;
  companyId: string;
  branchId?: string;
  categoryId: string;
  cashRegisterId?: string;
  amount: number;
  paymentMethod: string;
  reference?: string;
  notes?: string;
  expenseDate: string;
  createdAt?: string;
  category?: { id: string; name: string };
  createdBy?: { id: string; fullName: string };
}

export interface CategoriaGasto {
  id: string;
  companyId: string;
  name: string;
  description?: string;
  isActive: boolean;
}

export const gastosService = {
  async findAll(companyId: string, filters?: { branchId?: string; startDate?: string; endDate?: string }) {
    const response = await api.get('/expenses', { params: { companyId, ...filters } });
    return response.data;
  },

  async create(data: {
    companyId: string;
    branchId?: string;
    categoryId: string;
    cashRegisterId?: string;
    amount: number;
    paymentMethod: string;
    reference?: string;
    notes?: string;
    createdById?: string;
  }) {
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async update(id: string, data: {
    categoryId: string;
    amount: number;
    paymentMethod: string;
    reference?: string;
    notes?: string;
  }) {
    const response = await api.patch(`/expenses/${id}`, data);
    return response.data;
  },

  async remove(id: string) {
    const response = await api.delete(`/expenses/${id}`);
    return response.data;
  },

  async getCategories(companyId: string) {
    const response = await api.get('/expense-categories', { params: { companyId } });
    return response.data;
  },

  async createCategory(data: { companyId: string; name: string; description?: string }) {
    const response = await api.post('/expense-categories', data);
    return response.data;
  }
};
